import * as React from 'react';


export default (list, slug) => {
    return (
        <div key="listIndex">
            <h3>{list.title}</h3>
            <ul>
                {list.items.map((item, index) => {
                    if (typeof item === 'string') {
                        return (<li key={index}>{item}</li>)
                    } else {
                        const itemFile = require(`../assets/images/properties/${slug}/${item.url}`);

                        return (
                            <li key={index}>
                                <a href={itemFile}>{item.text}</a>
                            </li>
                        );
                    }
                })}
            </ul>
        </div>
    );
};